module.exports = __webpack_public_path__ + "fonts/IndivisibleWebBoldItalic.474858cf.woff";